import type { FC, PropsWithChildren } from 'react'

import styled from 'styled-components'

import { space } from 'theme/utils'

export const Wrapper = styled.section`
  flex: 1;
  display: flex;
  gap: ${space(2)};
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: ${space(14)} 0;
  > div {
    width: 100%;
  }
`

export const FillViewport: FC<PropsWithChildren> = ({ children }) => (
  <Wrapper>
    <div>{children}</div>
  </Wrapper>
)
